export default __webpack_public_path__ + "static/media/Applique.315fbc87.jpeg";